<template>
  <div>
    <el-card class="box-card">
      <el-row>
        <el-col :span="24"><div class="s-title">负面内容深度分析</div></el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="hist-table flex-top-btn">
            <div class="hist-anlys">
              <div class="title">内容特征词分析-负面内容占比</div>
              <div class="sel-label flex-cen-left">
                <div class="label-opt">
                  <div class="label">品类：</div>
                  <div class="sel-opt">
                    <el-select v-model="lineCateVal" placeholder="请选择">
                      <el-option v-for="item in cateList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="label-opt">
                  <div class="label">维度：</div>
                  <div class="sel-opt">
                    <el-select v-model="lineDimenVal" placeholder="请选择">
                      <el-option v-for="item in dimenList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="label-opt">
                  <div class="label">属性：</div>
                  <div class="sel-opt">
                    <el-select v-model="lineAttrVal" placeholder="请选择">
                      <el-option v-for="item in attrList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </div>
                </div>  
              </div>
              <div class="lineHhist"><LineHistChart /></div>
            </div>
            <div class="cmet-dti">
              <div class="title">评论内容明细</div>
              <div class="sel-label flex-cen-left">
                <div class="label-opt">
                  <div class="label">品类：</div>
                  <div class="sel-opt">
                    <el-select v-model="tblCateVal" placeholder="请选择">
                      <el-option v-for="item in cateList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </div>
                </div>  
                <div class="label-opt">
                  <div class="label">维度：</div>
                  <div class="sel-opt">
                    <el-select v-model="tblDimenVal" placeholder="请选择">
                      <el-option v-for="item in dimenList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </div>
                </div>  
                <div class="label-opt">
                  <div class="label">属性：</div>
                  <div class="sel-opt">
                    <el-select v-model="tblAttrVal" placeholder="请选择">
                      <el-option v-for="item in attrList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </div>
                </div>  
                <div class="label-opt">
                  <div class="label">特征词：</div>
                  <div class="sel-opt">
                    <el-select v-model="charaVal" placeholder="请选择">
                      <el-option v-for="item in charaList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="eltable">
                <el-table :data="tableData" style="width: 100%" class="eltable" height="350">
                  <el-table-column prop="chara" label="特征词" width="180"></el-table-column>
                  <el-table-column prop="date" label="日期" width="180"></el-table-column>
                  <el-table-column prop="time" label="时间"></el-table-column>
                  <el-table-column prop="content" label="内容"></el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import LineHistChart from './components/LineHistChart'
export default {
  components: { LineHistChart },
  data() {
    return {
      queryInfo: {// pagination
        query: '',
        pagenum: 1,
        pagesize: 10,
      },
      currentPage: 1,// current page
      total: 0,// total
      rules: {},// rule
      form: {},// form
      loading: true,
      cateList: [// 品牌
        {
          value: 0,
          label: '女装'
        },
        {
          value: 1,
          label: '男装'
        }
      ],
      lineCateVal: 0,// 品牌
      tblCateVal: 0,// 品牌
      dimenList: [// 维度
        {
          value: 0,
          label: '产品设计'
        },
        {
          value: 1,
          label: '产品'
        }
      ],
      lineDimenVal: 0,// 维度
      tblDimenVal: 0,// 维度
      attrList: [// 属性
        {
          value: 0,
          label: '拉链'
        },
        {
          value: 1,
          label: '拉链'
        }
      ],
      lineAttrVal: 0,// 属性
      tblAttrVal: 0,// 属性
      charaList: [// 特征词
        {
          value: 0,
          label: '所有'
        },
        {
          value: 1,
          label: '特征词'
        }
      ],
      charaVal: 0,// 特征词
      tableData: [{
        chara: '拉链重',
        date: '2019年7月12日',
        time: '16:04:13',
        content: '因数据敏感度原因评价内容无法展示'
      }, 
      {
       chara: '领口太低',
        date: '2019年7月4日',
        time: '17:10:45',
        content: '因数据敏感度原因评价内容无法展示'
      }, 
      {
        chara: '领口太低',
        date: '2019年8月6日',
        time: '23:23:30',
        content: '因数据敏感度原因评价内容无法展示'
      }, 
      {
        chara: '图案的位置太低',
        date: '2019年9月21日',
        time: '17:13:59',
        content: '因数据敏感度原因评价内容无法展示'
      },
      {
        chara: '图案有色差',
        date: '2019年8月22日',
        time: '11:51:47',
        content: '因数据敏感度原因评价内容无法展示'
      },
      {
        chara: '圆领百搭',
        date: '2019年7月7日',
        time: '21:43:31',
        content: '因数据敏感度原因评价内容无法展示'
      },]
    }
  },
  created() {
    
  },
  methods: {

  }
}
</script>

<style lang="scss" src="../assets/common.scss" scoped></style>
<style lang="scss" scoped>
.box-card{
  background-color: #F3F2F1;
  .s-title{
    width: 15rem;
    text-align: center;
    padding: 0.8rem 1rem;
    border-radius: 10px;
    margin: 1rem 0;
    font-size: 18px;
    background-color: #F8F7F6;
  }
  .title,.label-opt{
    margin-bottom: 2rem;
  }
  .axis{
    margin-bottom: 1rem;
  }
  .label-opt{
    margin-right: 1rem;
    .label{
      margin-bottom: 0.5rem;
    }
    .sel-opt{
      width: 10rem;
    }
  }
  .hist-table{
    background-color: #F7F6F6;
    padding-bottom: 1rem;
    .hist-anlys,.cmet-dti{
      width: 50%;
      .title{
        text-align: center;
        background-color: #FAF9F9;
        padding: 0.5rem 0;
      }
    }
    .hist-anlys{
      .title{
        margin: 1rem 5rem 1rem 2rem;
      }
    }
    .cmet-dti{
      .title{
        margin: 1rem 5rem 1rem 1rem;
      }
    }
  }
  .eltable{
    >>>.el-table__header-wrapper{
      thead{
        tr{
          th{
            border-bottom: 2px solid #989ABC;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/voc/cmetcontent/index.vue